import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DetalhesFaeResponse, Fae, faeRetornoRequest, faeRetornoResponse, ImprimirFaeRequest, ImprimirFaeResponse, listaMotivosResponse, RelatorioAcompanhamentoDeExpedicaoInput, RelatorioAcompanhamentoDeExpedicaoOutput, ValidarFaeRequest, ValidarGerarPreFaeRequest, ValidarGerarPreFaeRequestIndividual, ValidarGerarPreFaeResponse } from 'src/app/@shared/models/fae/fae.model';
import {
  AlterarFaeRequest,
  AlterarFaeResponse,
  GerarPreFaeRequest,
  GerarPreFaeResponse,
  ListarPrestadoresResponse,
  ListarRoteirosResponse,
  ListarVeiculosResponse,
  pedidosFAEResponse,
  ExpedirFaeResponse,
  listFAERequest,
  listFAEResponse,
  volumesFAERequest,
  volumesFAEResponse,
  VolumeFae,
  PreTrackFaeRemoverVolumeInput,
  expedirFAERequest
} from 'src/app/@shared/models/fae/gerar-pre-fae/fae.model';
import { ValidarManifestoTransferenciaRequest } from 'src/app/@shared/models/manifesto-transferencia.model';
import { BarcodeListarLoteResponse, BarcodeListarRequest, FormaBipagemResponse } from 'src/app/@shared/models/selecao-volumes/selecao-volumes.model';
import { montarQueryString } from '../base/base.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtro = (obj: BarcodeListarRequest | ValidarManifestoTransferenciaRequest) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
}

const PRINT_STORAGE_KEY = "PRINT-FAE";

@Injectable({
  providedIn: 'root'
})
export class FaeService {
  private httpClient: HttpClient;

  constructor(
    handler: HttpBackend,
    private http: HttpClient
  ) {
    this.httpClient = new HttpClient(handler);
  }

  listarFAE(obj: listFAERequest): Observable<listFAEResponse[]> {
    const filter = `${obj.dataInicio ? `dataInicio=${obj.dataInicio}&` : ''}` +
      `${obj.dataFim ? `dataFim=${obj.dataFim}&` : ''}` +
      `${obj.faeID ? `faeID=${obj.faeID}&` : ''}` +
      `${obj.motoristaID ? `motoristaID=${obj.motoristaID}&` : ''}` +
      `${obj.status ? `status=${obj.status}` : ''}`;
    return this.http.get<listFAEResponse[]>(
      `Fae/ListagemFae?${filter}`,
      httpOptions
    );
  }

  listarFAEVolumes(obj: volumesFAERequest): Observable<volumesFAEResponse[]> {
    const filter = `${obj.dataInicio ? `dataInicio=${obj.dataInicio}&` : ''}` +
      `${obj.dataFim ? `dataFim=${obj.dataFim}&` : ''}` +
      `${obj.agenteId ? `agenteId=${obj.agenteId}&` : ''}` +
      `${obj.faeId ? `faeId=${obj.faeId}&` : ''}` +
      `${obj.status ? `status=${obj.status}` : ''}`;
    return this.http.get<volumesFAEResponse[]>(
      `Fae/Volumes?${filter}`,
      httpOptions
    );
  }

  encontraVolumes(barcode: string): Observable<pedidosFAEResponse[]> {
    const filter = `${barcode ? `barcode=${barcode}` : ''}`;
    return this.http.get<pedidosFAEResponse[]>(
      `Fae/GetFaeByVolumeBarcode?${filter}`, httpOptions);
  }

  barcodeListarMultiplo(obj: BarcodeListarRequest): Observable<BarcodeListarLoteResponse[]> {
    const filter =
      `${obj.tipoConsulta ? `&tipoConsulta=${obj.tipoConsulta}&` : ''}`;
    return this.http.get<BarcodeListarLoteResponse[]>(
      `Barcode/ListarEmLote?Barcode=${obj.barcode}${filter}`,
      httpOptions
    );
  }

  barcodeListaVolume(obj: BarcodeListarRequest): Observable<VolumeFae[]> {
    const filter =
      `${obj.tipoConsulta ? `&tipoConsulta=${obj.tipoConsulta}&` : ''}`;
    return this.http.get<VolumeFae[]>(
      `Barcode/ListaVolumes?Barcode=${obj.barcode}${filter}`,
      httpOptions
    );
  }

  public listarMotoristas(): Observable<any[]> {
    return this.http.get<any[]>(`Fae/ListagemEntregador`);
  }

  verificaFormaBipagem(barcode: string): Observable<FormaBipagemResponse> {
    return this.http.get<FormaBipagemResponse>(
      `Barcode/FormaBipagem?Barcode=${barcode}`,
      httpOptions
    );
  }

  listarRoteiros(): Observable<ListarRoteirosResponse[]> {
    return this.http.get<ListarRoteirosResponse[]>(
      `Fae/ListagemRoteiro`,
      httpOptions
    );
  }

  listarVeiculos(): Observable<ListarVeiculosResponse[]> {
    return this.http.get<ListarVeiculosResponse[]>(
      `Fae/TipoVeiculo`,
      httpOptions
    );
  }

  listarPrestadores(agenteId?: number): Observable<ListarPrestadoresResponse[]> {
    return this.http.get<ListarPrestadoresResponse[]>(
      `Fae/ListagemEntregador?agenteId=${agenteId ?? 0}`,
      httpOptions);
  }


  validarAlterarFae(obj: ValidarFaeRequest): Observable<ValidarGerarPreFaeResponse[]> {
    return this.http.post<ValidarGerarPreFaeResponse[]>(
      `Fae/ValidarPedido`,
      obj,
      httpOptions);
  }

  validarGerarPreFae(obj: ValidarGerarPreFaeRequest): Observable<ValidarGerarPreFaeResponse[]> {
    return this.http.post<ValidarGerarPreFaeResponse[]>(
      `Fae/ValidarPedido`,
      obj,
      httpOptions);
  }

  validarGerarPreFaeIndividual(obj: ValidarGerarPreFaeRequestIndividual): Observable<ValidarGerarPreFaeResponse[]> {
    return this.http.post<ValidarGerarPreFaeResponse[]>(
      `Fae/ValidarPedido`,
      obj,
      httpOptions);
  }

  gerarPreFae(obj: GerarPreFaeRequest): Observable<GerarPreFaeResponse> {
    return this.http.post<GerarPreFaeResponse>(
      `Fae/GerarPreFae`,
      obj,
      httpOptions);
  }

  removerPedido(obj: PreTrackFaeRemoverVolumeInput): Observable<any> {
    return this.http.put<any>(
      `Fae/PreTrackFaeRemoverVolume`,
      obj,
      httpOptions);
  }

  alterarFae(faeId: number, obj: AlterarFaeRequest): Observable<AlterarFaeResponse> {
    return this.http.put<AlterarFaeResponse>(
      `Fae/${faeId}/Alterar`,
      obj,
      httpOptions
    );
  }

  expedirFae(obj: expedirFAERequest): Observable<ExpedirFaeResponse> {
    return this.http.post<ExpedirFaeResponse>(`Fae/Expedir/`, obj, httpOptions);
  }

  pedidosFAE(obj: any): Observable<pedidosFAEResponse[]> {
    const filter = `${obj.temp ? `temp=${obj.temp}` : ''}`;
    return this.http.get<pedidosFAEResponse[]>(
      `Fae/${obj.faeId}/Pedidos?${filter}`, httpOptions);
  }
  
  volumesFAE(obj: any): Observable<VolumeFae[]> {
    const filter = `${obj.temp ? `temp=${obj.temp}` : ''}`;
    return this.http.get<VolumeFae[]>(
      `Fae/${obj.faeId}/PedidosVolume?${filter}`, httpOptions);
  }

  listaMotivosRetornoFae(): Observable<listaMotivosResponse[]> {
    return this.http.get<listaMotivosResponse[]>(`Fae/MotivoRetorno`, httpOptions);
  }

  retornarFAE(obj: faeRetornoRequest): Observable<faeRetornoResponse[]> {
    return this.http.post<faeRetornoResponse[]>(`Fae/Retorno`, obj, httpOptions);
  }

  listaEntregaFAE(faeId: number, temp: boolean): Observable<Fae> {
    return this.http
      .get<any>(`Fae/ListaEntregaFAE/${faeId}?temp=${temp}`, httpOptions);
  }

  imprimirFae(obj: ImprimirFaeRequest): Observable<ImprimirFaeResponse> {
    return this.http.get<ImprimirFaeResponse>(
        `Fae/${obj.faeId}/Impressao?temp=${obj.temp}`, httpOptions);
  }

  detalhesFae(faeId: number, temp: boolean): Observable<DetalhesFaeResponse> {
    return this.http.get<DetalhesFaeResponse>(`Fae/Consulta/Detalhes?faeId=${faeId}&temp=${temp}`, httpOptions);
  }

  relatorioAcompanhamentoExpedicao(obj: RelatorioAcompanhamentoDeExpedicaoInput): Observable<RelatorioAcompanhamentoDeExpedicaoOutput[]> {
    return this.http.get<RelatorioAcompanhamentoDeExpedicaoOutput[]>(`Fae/RelatorioAcompanhamentoDeExpedicao?${montarQueryString(obj)}`, httpOptions);
  }

  exportarRelatorioAcompanhamentoExpedicao(obj: RelatorioAcompanhamentoDeExpedicaoInput): Observable<any> {
    return this.http.get<any>(`Fae/ExportarRelatorioAcompanhamentoDeExpedicao?${montarQueryString(obj)}`, httpOptions);
  }

  private printSelectedSubject = new BehaviorSubject<string>(
    this.getPrintSelectedInCookie()
  );

  public getPrintSelected() {
    return this.printSelectedSubject.asObservable() as Observable<string | undefined>;
  }

  private getPrintSelectedInCookie() {
    const print = getCookie(PRINT_STORAGE_KEY);
    if (print) {
      try {
        return JSON.parse(print);
      } catch {
        return print;
      }
    }
  }

  public setPrintSelected(print: string) {
    this.setPrintSelectedInCookie(print);
    this.printSelectedSubject.next(print);
  }

  private setPrintSelectedInCookie(print: string) {
    createCookie(PRINT_STORAGE_KEY, JSON.stringify(print));
  }
  

}

function createCookie(name: string, value: string) {
  document.cookie = `${name}=${value};path=/`;
}

function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {return parts.pop().split(";").shift()} else return null;
}

